(function () {
  const RESTRICTED_TAG = 'singleQuantity';
  const tagCache = new Map();

  async function getProductTags(handle) {
    if (tagCache.has(handle)) return tagCache.get(handle);
    try {
      const product = await (await fetch(`/products/${handle}.js`)).json();
      tagCache.set(handle, product.tags || []);
      return product.tags || [];
    } catch {
      return [];
    }
  }

  async function correctCart() {
    let cart;
    try {
      cart = await (await fetch('/cart.js')).json();
    } catch {
      return;
    }

    let corrected = false;

    for (const item of cart.items) {
      if (item.quantity <= 1) continue;
      const tags = await getProductTags(item.handle);
      if (!tags.includes(RESTRICTED_TAG)) continue;

      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 1 }),
        });
        corrected = true;
      } catch {}
    }

    if (corrected) {
      // Don't yank the page out from under someone mid-typing
      const activeTag = document.activeElement?.tagName;
      if (activeTag !== 'INPUT' && activeTag !== 'TEXTAREA') {
        location.reload();
      }
    }
  }

  document.addEventListener('DOMContentLoaded', correctCart);
  setInterval(correctCart, 1500);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') correctCart();
  });
})();